import React from 'react';

import { Heading, Text } from '~/components/core';
import InnerTabs from '~/components/core/Layout/InnerTabs/InnerTabs';

import AllReportsTab from '../GeneratedReports/AllReportsTab';
import ReportTemplatesTab from '../ReportTemplates/ReportTemplatesTab';
import SubscriptionRulesTab from '../SubscriptionRules/SubscriptionRulesTab';

const BORDEREAUX_ROUTES = {
  ALL_REPORTS: 'all-reports',
  TEMPLATES: 'templates',
  SUBSCRIPTION_RULES: 'subscription-rules',
};

const BordereauxReportingTab: React.FC = () => {
  const tabs = [
    {
      label: 'All Reports',
      url: BORDEREAUX_ROUTES.ALL_REPORTS,
      component: AllReportsTab,
    },
    {
      label: 'Templates',
      url: BORDEREAUX_ROUTES.TEMPLATES,
      component: ReportTemplatesTab,
    },
    {
      label: 'Subscription Rules',
      url: BORDEREAUX_ROUTES.SUBSCRIPTION_RULES,
      component: SubscriptionRulesTab,
    },
  ];

  return (
    <div className="p-20">
      <div className="mb-16">
        <Heading variant={Heading.TYPES.H2}>Reporting</Heading>
        <Text weight={Text.WEIGHTS.REGULAR} variant={Text.VARIANTS.SM} className="mt-10">
          Generate new reports or review previously created ones with ease
        </Text>
      </div>
      <InnerTabs tabs={tabs} />
    </div>
  );
};

export default BordereauxReportingTab;
